import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Agents from './pages/Agents'
import Tasks from './pages/Tasks'
import Deployments from './pages/Deployments'
import AIChat from './pages/AIChat'
import Monitor from './pages/Monitor'
import AgentTeam from './pages/AgentTeam'
import Settings from './pages/Settings'
import LongRunningTask from './pages/LongRunningTask'
import WorkflowHistory from './pages/WorkflowHistory'
import CodeViewer from './pages/CodeViewer'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="agents" element={<Agents />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="deployments" element={<Deployments />} />
        <Route path="chat" element={<AIChat />} />
        <Route path="team" element={<AgentTeam />} />
        <Route path="monitor" element={<Monitor />} />
        <Route path="long-running-task" element={<LongRunningTask />} />
        <Route path="history" element={<WorkflowHistory />} />
        <Route path="settings" element={<Settings />} />
        <Route path="code-viewer" element={<CodeViewer />} />
      </Route>
    </Routes>
  )
}

export default App
